<template>
    <transition name="fade">
        <Edit v-if="editModal" :loja="loja" @changeVisibility="editModal = false" @close="closeEditModal"/>
    </transition>
    <transition name="fade">
        <Remove v-if="removeModal" @changeVisibility="removeModal = false" @remove="remove()"/>
    </transition>
    <transition name="fade">
        <Finalizar v-if="finalizarModal" @changeVisibility="finalizarModal = false" @finalizar="finalizar()"/>
    </transition>
    <section class="w-full h-full flex py-12" v-if="initialLoading">
        <section class="rounded-lg mt-40 text-gray-300 flex items-center flex-col w-full h-min ">
            <span class="animate-spin material-icons-outlined text-center dark:text-gray-300 select-none text-9xl ">
                autorenew
            </span>
            <p class="text-4xl text-center animate-pulse">Preparando pesquisa...</p>
        </section>
    </section>
    <div v-else class="w-full h-full flex py-12">
        <section v-if="!loja" class="rounded-lg mt-40 text-gray-300 flex items-center flex-col w-full h-min ">
            <span class="material-icons-outlined text-center dark:text-gray-300 select-none text-9xl ">
                production_quantity_limits
            </span>
            <p class="text-2xl text-center">Esta loja ainda não é ativa</p>
            <button @click="router.push('/dashboard/lojas/adesao')" class="btn bg-indigo-500 rounded-full py-2 px-8 mt-4 text-xl">Retornar</button>
        </section>
        <section v-else class="w-3/4 h-full mx-auto  flex flex-col gap-y-4 ">
            <div v-if="actualStep !== 5 && actualStep !== 4" class="w-full flex flex-row-reverse">
                <button @click="wip()" class="btn text-gray-100 bg-indigo-500 rounded-md h-10 text-sm w-32">Salvar recolha</button>
            </div>
            <section id="step-0" :class="actualStep === STEP0 ? 'h-56 mb-8' : 'h-12'" class="flex flex-col gap-y-2 transition-all duration-500">
                <section id="icon-step-0" class="h-12 flex flex-row flex-wrap gap-x-4 transition-all duration-500">
                    <div @click="clickIcons(STEP0); goBack()" :class="completedSteps.includes(STEP0) ? ' bg-indigo-600 border-0' : actualStep === STEP0 ? 'border-indigo-600 border-2' : 'border-gray-500 border-2' " class="flex-shrink-0 w-12 h-12 rounded-full cursor-pointer">
                        <span class="flex flex-col h-full">
                            <span v-if="!completedSteps.includes(STEP0)" :class="completedSteps.includes(STEP0) || actualStep === STEP0 ? ' dark:text-gray-100 text-indigo-600' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                            tune
                            </span>
                            <span v-else :class="completedSteps.includes(STEP0) || actualStep === STEP0 ? ' text-gray-100' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                                check
                            </span>
                        </span>
                    </div>
                    <p class="flex-1 flex-shrink-0 self-center dark:text-gray-300 text-gray-600">Preparação para pesquisa</p>
                </section>
                <transition name="fade">
                    <section v-if="actualStep === STEP0" id="container-step0" class="w-11/12 mx-auto h-full dark:bg-gray-800 bg-gray-100 border dark:border-gray-700 border-gray-200 transition-all duration-500 rounded-lg p-4 shadow-lg flex flex-col lg:flex-row py-2 gap-x-8 px-5">
                        <div class="flex flex-col content-around h-full">
                                <div><p class="text-lg dark:text-indigo-400 text-indigo-600">{{loja.razao_social}}</p></div>
                                <div><p class="text dark:text-indigo-200 text-indigo-400">{{loja.nome_fantasia}}</p></div>
                                <div><p class="text-sm dark:text-gray-200 text-gray-600">{{cnpjMask(loja.cnpj)}}</p></div>
                                <div><p class="text-sm dark:text-gray-200 text-gray-600 font-bold">{{loja.segmento}}</p></div>
                                <div class="mt-2">
                                    <p class="dark:text-gray-300 text-gray-500 text-sm">{{phoneMask(loja.telefone1) ? phoneMask(loja.telefone1) :  phoneMask(loja.telefone2) ? phoneMask(loja.telefone1) : 'Não há telefones cadastrados'}} - {{loja.nome_contato ? loja.nome_contato : 'Sem informação de contato'}}</p>
                                    <p class="dark:text-gray-300 text-gray-500 text-sm">{{loja.email}}</p>
                                </div>
                                <div class="mt-4 flex flex-row items-center text-gray-400">
                                    <span class="material-icons md-12">location_on</span>
                                    <p v-if="loja.endereco" class="uppercase text-xs break-words">{{loja.endereco.endereco}}, {{loja.endereco.numero}}, {{loja.endereco.bairro}} - {{loja.endereco.cidade}} - {{loja.endereco.estado}}</p>
                                </div>
                            </div>
                            <div class="flex-1 justify-center self-center">
                                <div class="flex flex-col gap-y-2">
                                    <div v-if="loja.endereco">
                                        <p class="text-center text-sm dark:text-gray-500 text-gray-600 uppercase">Região</p>
                                        <p class="text-center text dark:text-indigo-200 text-indigo-600">{{loja.endereco.regiao}}</p>
                                    </div>
                                    <div>
                                        <p class="text-center text-sm dark:text-gray-500 text-gray-600 uppercase">Faturamento</p>
                                        <p class="text-center text dark:text-indigo-200 text-indigo-600">{{loja.faturamento}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-1 justify-center self-center flex flex-col gap-y-2 items-center">
                                <p class="dark:text-gray-500 text-gray-600 text-xs text-center">PESQUISA A SER REALIZADA POR:</p>
                                <div v-if="loja.pesquisador_id" class="w-16 h-16 bg-indigo-300 rounded-full">
                                    <img v-if="loja.pesquisador_avatar" class="rounded-full " :src="loja.pesquisador_avatar" alt="">
                                    <span v-else class="h-full w-full flex"><p class="m-auto text-2xl text-gray-100">{{loja.pesquisador[0]}}{{loja.pesquisador.split(' ')[1][0]}}</p></span>
                                </div>
                                <span v-else class="material-icons-outlined text-6xl text-indigo-200">
                                    person_add
                                </span>
                                <p class="dark:text-gray-200 text-gray-500 text-center">{{loja.pesquisador ? loja.pesquisador : 'Nenhum pesquisador selecionado'}}</p>
                            </div>
                            <div class="flex-1 md:flex-0 lg:w-1/12 justify-center self-center flex flex-col items-center">
                                <button v-if="!completedSteps.includes(STEP0)" @click="nextStep(STEP0);" class="text-indigo-500">CONFIRMAR</button>
                                <button v-else @click="previousStep(STEP0)" class="text-indigo-500">DESCONFIRMAR</button>
                                <button @click="editModal = true" class="text-indigo-300">Editar</button>
                            </div>
                    </section>
                </transition>
            </section>
            <section id="step-1" :class="actualStep === STEP1 ? 'h-3/4' : 'h-12'" class="flex flex-col gap-y-2 transition-all duration-500 w-full">
                <section id="icon-step-2" class="h-12 flex flex-row flex-wrap gap-x-4 transition-all duration-500">
                    <div @click="clickIcons(STEP1); goBack()" :class="completedSteps.includes(STEP1) ? ' bg-indigo-600 border-0' : actualStep === STEP1 ? 'border-indigo-600 border-2' : 'border-gray-500 border-2' " class="w-12 h-12 rounded-full cursor-pointer">
                        <span class="flex flex-col h-full">
                            <span v-if="!completedSteps.includes(STEP1)" :class="completedSteps.includes(STEP1) || actualStep === STEP1 ? ' dark:text-gray-100 text-indigo-600' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                                content_paste
                            </span>
                            <span v-else :class="completedSteps.includes(STEP1) || actualStep === STEP1 ? ' text-gray-100' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                                check
                            </span>
                        </span>
                    </div>
                    <p class="flex-1 flex-shrink-0 self-center dark:text-gray-300 text-gray-600">Última recolha</p>
                </section>
                <transition name="fade">
                    <section v-if="actualStep === STEP1" id="container-step0" class="h-full w-11/12 mx-auto transition-all duration-500 rounded-lg p-4 dark:shadow-sm shadow-md py-4">
                        <div  class="flex flex-col h-full gap-y-0">
                            <div v-if="ultimaRecolha.length == 0" class="rounded-lg h-40 text-gray-500 dark:text-gray-300 flex flex-col">
                                <span class="material-icons-outlined text-center items-center dark:text-gray-300 select-none text-9xl mx-auto">
                                    content_paste_off
                                </span>
                                <p class="text-xl text-center">Essa loja não possui recolhas prévias</p>
                            </div>
                            <span v-else>
                                <p class="dark:text-indigo-200 text-gray-700 self-center w-full ml-2 text-sm uppercase mb-4">Recolha realizada em <strong>{{dataMask(ultimaRecolha.recolha.pesquisa_realizada_em).split(' ')[0]}}</strong> às <strong>{{horaMask(ultimaRecolha.recolha.pesquisa_realizada_em)}}</strong> </p>
                                <div class="ml-4">
                                    <p class="uppercase text-gray-600 dark:text-gray-300 text-xs">realizada por: </p>
                                    <div class="flex flex-row items-center gap-x-2 mt-1">
                                        <div class="h-12 w-12 bg-indigo-700 rounded-full">
                                            <img v-if="ultimaRecolha.recolha.pesquisador.avatar" class="rounded-full" :src="ultimaRecolha.recolha.pesquisador.avatar" alt="">
                                            <span v-else class="h-full w-full flex"><p class="text-gray-100 m-auto text-2xl">{{ultimaRecolha.recolha.pesquisador.nome[0]}}{{ultimaRecolha.recolha.pesquisador.nome.split(' ')[1][0]}}</p></span>
                                        </div>
                                        <p class="uppercase  text-gray-600 dark:text-gray-300 text-xs">{{ultimaRecolha.recolha.pesquisador.nome}}</p>
                                    </div>
                                </div>
                                <div class="ml-4 w-full ">
                                    <div class="flex justify-between mt-4 mb-2">
                                        <p class="uppercase text-gray-600 dark:text-gray-300 text-sm">PRODUTOS</p>
                                        <div class="flex items-center gap-x-2">
                                            <p class="uppercase text-gray-500 dark:text-gray-300 text-xs">Pesquisar produto: </p>
                                            <input v-model="produtoUltimaRecolha" class="bg-transparent text-gray-500 border-b border-gray-500 dark:border-indigo-200 transition-all duration-300 focus:border-indigo-500"/>
                                        </div>
                                    </div>
                                    <div class="flex flex-wrap gap-4 overflow-y-scroll h-96 pl-4 pr-2 content-start">
                                        <div v-for="produto, i in filteredultimaRecolhaProdutos" :key="i" class="rounded-lg w-1/2 overflow-hidden group hover:w-full transition-all duration-300 h-20 flex">
                                            <div class="bg-indigo-500 w-12 rounded-l-lg flex text-gray-100 items-center justify-center border-indigo-600 border border-r-0">
                                                {{produto.quantidade}}x
                                            </div>
                                            <div class="bg-gray-200 dark:bg-gray-800 px-2 py-1 border-gray-300 dark:border-gray-700 border w-full border-r-0 flex">
                                                <div class="w-full">
                                                    <p class="text-sm text-indigo-500">{{produto.marca}} {{produto.modelo}}</p>
                                                    <p class="overflow-y-hidden text-gray-600 dark:text-gray-300">{{produto.complemento}}</p>
                                                </div>
                                                <div class="w-full group-hover:inline-block hidden transition-all duration-300">
                                                    <p class="uppercase text-gray-600 dark:text-gray-300 text-sm">Observações </p>
                                                    <p class="pl-4 uppercase text-gray-600 dark:text-gray-300 text-xs">{{produto.observacao ? produto.observacao : ' Não possui observações'}}</p>
                                                </div>
                                            </div>
                                            <div class="bg-gray-200 dark:bg-gray-800 w-32 rounded-r-lg flex items-center justify-center border-gray-300 dark:border-gray-700 border border-l-0">
                                                <p class="text-lg text-indigo-600 dark:text-indigo-400">R$ {{produto.valor}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </span>

                            <div class="w-full flex flex-row justify-end gap-x-4 mt-4">
                                <button @click="previousStep(STEP1)" class="btn dark:text-gray-300 text-gray-800">Voltar</button>
                                <button @click="nextStep(STEP1)" class="btn w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading">
                                    Próximo
                                </button>
                            </div>
                        </div>
                    </section>
                </transition>
            </section>
            <section id="step-2" :class="actualStep === STEP2 ? 'h-3/4' : 'h-12'" class="flex flex-col gap-y-2 transition-all duration-500 ">
                <section id="icon-step-1" class="h-12 flex flex-row flex-wrap gap-x-4 transition-all duration-500">
                    <div @click="clickIcons(STEP2); goBack()" :class="completedSteps.includes(STEP2) ? ' bg-indigo-600 border-0' : actualStep === STEP2 ? 'border-indigo-600 border-2' : 'border-gray-500 border-2' " class="w-12 h-12 rounded-full cursor-pointer">
                        <span class="flex flex-col h-full">
                            <span v-if="!completedSteps.includes(STEP2)" :class="completedSteps.includes(STEP2) || actualStep === STEP2 ? ' dark:text-gray-100 text-indigo-600' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                                add_shopping_cart
                            </span>
                            <span v-else :class="completedSteps.includes(STEP2) || actualStep === STEP2 ? ' text-gray-100' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                                check
                            </span>
                        </span>
                    </div>
                    <p class="flex-1 flex-shrink-0 self-center dark:text-gray-300 text-gray-600">Adicionar produtos</p>
                </section>
                <transition name="fade">
                    <section v-if="actualStep === STEP2" id="container-step0" class="w-11/12 mx-auto h-full transition-all duration-500 rounded-lg p-4 dark:shadow-sm shadow-md py-4">
                        <div class="flex flex-col h-full gap-y-2">

                            <p class="dark:text-indigo-200 text-gray-600 self-center w-full ml-2 text-sm uppercase mb-4">Adicione novos produtos à loja</p>
                            <div class="flex flex-row gap-x-4 w-full">
                                <span class="flex-1">
                                    <Autocomplete v-model="selectedMarca" label="Marcas" placeholder="Selecionar marca" :list="marcas" desc="marca" @filter="filterModelos()"/>
                                </span>
                                <span class="flex-1">
                                    <Autocomplete v-model="selectedModelo" label="Modelos" placeholder="Selecionar modelo" :list="modelos" desc="descricao" @filter="filterComplementos()" :disabled="selectedMarca === ''"/>
                                </span>
                            </div>

                            <div class="bg-gray-300 dark:bg-gray-800 bg-opacity-20 mt-4 border border-gray-300 dark:border-gray-600 rounded-lg flex-1 py-2 overflow-y-scroll dark:text-gray-300 font-bold max-h-96">
                                <span class="flex items-center" v-for="c, i in filteredListComplementos" :key="i" >
                                    <p class="py-1 px-4 text-gray-600 dark:text-gray-300">{{c.descricao}}</p>
                                    <button @click="addProduct(c.id)" class="btn text-indigo-500 px-2 rounded-full">+ add</button>
                                </span>
                                <p class="text-sm uppercase mx-auto text-center select-none text-gray-600 dark:text-gray-300" v-if="filteredListComplementos.length == 0 && selectedMarca && selectedModelo">Todos os produtos dessa marca e modelo adicionados</p>
                            </div>
                            <div class="w-full flex flex-row justify-end gap-x-4 mt-4">
                                <button @click="previousStep(STEP2)" class="btn dark:text-gray-300 text-gray-800">Voltar</button>
                                <button @click="nextStep(STEP2); getRegisteredProducts(1)" class="btn bg-indigo-600 h-10 px-4 rounded-lg text-gray-100 text-sm" :disabled="(registeredProducts.length == 0 && selectedProdutos.length == 0)">Próximo</button>
                            </div>
                        </div>
                    </section>
                </transition>
            </section>
            <section id="step-3" :class="actualStep === STEP3 ? 'h-3/4' : 'h-12'" class="flex flex-col gap-y-2 transition-all duration-500 ">
                <section id="icon-step-3" class="h-12 flex flex-row flex-wrap gap-x-4 transition-all duration-500">
                    <div @click="clickIcons(STEP3); getRegisteredProducts(1)" :class="completedSteps.includes(STEP3) ? ' bg-indigo-600 border-0' : actualStep === STEP3 ? 'border-indigo-600 border-2' : 'border-gray-500 border-2' " class="w-12 h-12 rounded-full cursor-pointer">
                        <span class="flex flex-col h-full">
                            <span v-if="!completedSteps.includes(STEP3)" :class="completedSteps.includes(STEP3) || actualStep === STEP3 ? ' dark:text-gray-100 text-indigo-600' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                                content_paste
                            </span>
                            <span v-else :class="completedSteps.includes(STEP3) || actualStep === STEP3 ? ' text-gray-100' : 'text-gray-500' " class="text-center material-icons-outlined my-auto select-none ">
                                check
                            </span>
                        </span>
                    </div>
                    <p class="flex-1 flex-shrink-0 self-center dark:text-gray-300 text-gray-600">Recolha</p>
                </section>
                <transition name="fade">
                    <section v-show="actualStep === STEP3" id="container-step0" class="w-11/12 mx-auto h-full transition-all duration-500 rounded-lg p-4 shadow-md dark:shadow-sm py-4">
                        <div class="flex flex-col h-full gap-y-0">
                            <p class="dark:text-indigo-200 text-gray-600 self-center ml-2 uppercase mb-4 w-full">Realizar recolha</p>
                            <div class="h-auto overflow-y-scroll px-4 py-2 rounded-xl grid grid-flow-col grid-cols-10 gap-x-4 w-full text-gray-600 dark:text-gray-300 uppercase text-sm">
                                <!-- <p class="self-center flex-1 flex-shrink ">Marca</p>
                                <p class="self-center flex-1 flex-shrink">Modelo</p>
                                <p class="self-center w-1/3 flex-grow break-normal whitespace-normal text-sm">Complemento</p> -->
                                <p class="col-span-6">Produto</p>
                                <p class="col-span-1">Preço médio</p>
                                <p class="col-span-1">Preço atual</p>
                                <p class="col-span-1">Quantidade</p>
                                <p class="col-span-1"></p>
                            </div>
                            <div class="flex-1 max-h-96 overflow-y-scroll px-2 py-2 rounded-xl flex flex-col gap-y-3">
                                <div v-for="produto, i in registeredProducts" :key="i"
                                :class="produto.valor === '0,00' ? 'ring ring-indigo-500' : ''"
                                class="grid grid-flow-col grid-cols-10 gap-x-4 rounded-lg mb-1 bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-800 bg-opacity-40 shadow-md h-auto text-gray-500 dark:text-gray-200">
                                    <div class="col-span-6 flex flex-col justify-items-center w-full py-4 px-8">
                                        <p class="text-indigo-400 text-sm">{{produto.marca}}</p>
                                        <p class="text-gray-200">{{produto.modelo_descricao}}</p>
                                        <p class="text-gray-400 text-xs">{{produto.complemento}}</p>
                                    </div>
                                    <div class="self-center w-full relative h-12">
                                        <input disabled=true v-model="produto.preco_medio" placeholder="0,00" class="w-full h-full pl-7 bg-transparent rounded-lg placeholder-gray-500 ring ring-transparent focus:ring-indigo-500"/>
                                        <label class="absolute top-3 select-none ">R$</label>
                                    </div>
                                    <div class="self-center w-full relative h-12">
                                        <input v-money3="config" min="0" placeholder="0,00" v-model.lazy="produto.valor" class="w-full h-full pl-7 bg-transparent rounded-lg placeholder-gray-500 ring ring-transparent focus:ring-indigo-500" type="text"/>
                                        <label class="absolute top-3 select-none ">R$</label>
                                        <div :class=" isGreaterThan20(produto) ? 'text-red-600' : 'text-yellow-500' " class="flex text-xs gap-x-1 items-center absolute top-3/4 -mt-1 w-full break-normal whitespace-nowrap" v-if="vIfPercent(produto)">
                                            <span class="material-icons-outlined">
                                                {{isGreaterThan20(produto) ? 'trending_up' : 'trending_down'}}
                                            </span>
                                            <p>{{percentCalc(produto)}}</p>
                                        </div>
                                    </div>
                                    <div class="self-center w-4/5 relative h-12">
                                        <input min="0" type="text" v-model="produto.quantidade" placeholder="0" class="w-full h-full bg-transparent rounded-lg placeholder-gray-500 ring ring-transparent focus:ring-indigo-500 pl-2"/>
                                    </div>
                                    <button tabindex="-1" @click="openRemoveModal(produto.marca_id, produto.modelo_id, produto.complemento_id)" class="self-center w-14 flex-shrink text-xs text-indigo-500 dark:text-indigo-200">REMOVER</button>
                                </div>
                            </div>

                            <div class="w-full flex flex-row justify-end gap-x-4 mt-4">
                                <button @click="previousStep(STEP3); getRegisteredProducts(); goBack()" class="btn  dark:text-gray-300 text-gray-800">Voltar</button>
                                <button @click="confirmaFinalizar()" class="btn w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="loading">
                                    <span :class="loading ? 'animate-pulse' : ''"> {{loading ? 'Finalizando recolha...' : 'Finalizar recolha'}}</span>
                                </button>
                            </div>
                        </div>
                    </section>
                </transition>
            </section>
            <section id="step-4" v-if="actualStep === STEP4" :class="actualStep === STEP4 ? 'h-52 opacity-100' : 'h-12 opacity-0'" class="flex px-16 transition-all duration-500 select-none">
                <div class="m-auto w-full flex flex-col gap-y-2">
                    <span class="material-icons-outlined text-center items-center text-gray-700 dark:text-gray-300 select-none text-9xl mx-auto">
                        verified
                    </span>
                    <p class="text-center text-gray-700 dark:text-gray-300 text-2xl">Recolha realizada com sucesso!</p>
                    <button @click="router.push('/dashboard/lojas/ativas')" class="btn h-12 bg-indigo-600 w-auto px-4 rounded-lg m-auto mt-2 text-gray-50">Realizar nova pesquisa</button>
                </div>
            </section>
            <section id="step-5" v-if="actualStep === STEP5" :class="actualStep === STEP5 ? 'h-52 opacity-100' : 'h-12 opacity-0'" class="flex px-16 transition-all duration-500 select-none">
                <div class="m-auto w-full flex flex-col gap-y-2">
                    <span class="material-icons-outlined text-center items-center text-gray-700 dark:text-gray-300 select-none text-9xl mx-auto">
                        save
                    </span>
                    <p class="text-center text-gray-700 dark:text-gray-300 text-2xl">Recolha salva com sucesso!</p>
                    <p class="text-center text-gray-700 dark:text-gray-300 text-lg">Esta recolha agora possuí status 'Em progresso' e poderá ser continuada posteriormente por você ou pelo administrador.</p>
                    <button @click="router.push({ name: 'DetalheAtivas', params: { id: loja.id }})" class="btn h-12 bg-indigo-600 w-auto px-4 rounded-lg m-auto mt-2 text-gray-50">Ver recolha</button>
                    <button @click="router.push('/dashboard/lojas/ativas')" class="btn w-auto rounded-lg m-auto text-gray-800 dark:text-gray-300">Voltar para lojas ativas</button>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import { ref, computed } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'
import { GET_MARCAS_BY_SEGMENTO, GET_MODELOS_BY_MARCA, GET_COMPLEMENTOS_BY_MODELO, GET_LOJAS_ATIVAS_FILTER, POST_PRODUTOS_LOJA, GET_PRODUTOS_BY_LOJA, POST_RECOLHA, DELETE_PRODUTOS_LOJA, GET_ULTIMA_RECOLHA, POST_HISTORICO_CONTATOS_ATIVAS, SAVE_RECOLHA_EM_PROGRESSO, POST_RECOLHA_EM_PROGRESSO } from '../../mixins/api'
import { onMounted } from '@vue/runtime-core'
import { cnpjMask as cnpj_mask, timeFormat, telephoneMask, dateTimeFormat } from '../../mixins/mask'
import { findId } from '../../mixins/findData'
import Input from '../Design/Input.vue'
import Select from '../Design/Select.vue'
import DatePicker from '../Design/Datepicker.vue'
import Autocomplete from '../Design/Autocomplete.vue'
import Table from '../Design/Table.vue'
import { displayNotification } from '../../mixins/notification'
import Spinner from '../Design/Spinner.vue'
import Edit from '../EditEmpresaModal/Modal.vue'
import Remove from './ModalRemove.vue'
import Finalizar from './FinalizarModal.vue'
import { Money3Directive } from 'v-money3'
import { useStore } from 'vuex'

export default {
    name: 'Pesquisa',
    directives: { money3: Money3Directive },
    components: {
        Input,
        Select,
        Autocomplete,
        Table,
        DatePicker,
        Spinner,
        Edit,
        Remove,
        Finalizar
    },
    setup () {
        const editModal = ref(false)
        const removeModal = ref(false)
        const finalizarModal = ref(false)

        // Stepper
        const STEP0 = 0
        const STEP1 = 1
        const STEP2 = 2
        const STEP3 = 3
        const STEP4 = 4
        const STEP5 = 5
        const actualStep = ref(0)
        const completedSteps = ref([-1])

        const clickIcons = (step) => {
            if ((completedSteps.value.includes(step - 1) && actualStep.value != STEP4)) { actualStep.value = step }
        }

        const store = useStore()
        const route = useRoute()
        const router = useRouter()
        const loja = ref({})

        const userViewer = store.getters['auth/user']

        const date = new Date()
        const anomes = ref('')

        const selectCurrentDate = () => {
            anomes.value = date.getFullYear().toString() + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1))
        }

        const marcas = ref([])
        const selectedMarca = ref('')
        const modelos = ref([])
        const selectedModelo = ref('')
        const complementos = ref([])
        const selectedComplemento = ref('')

        const registeredProducts = ref([])
        const getRegisteredProducts = async (check) => {
            let provisorio = []
            await GET_PRODUTOS_BY_LOJA(loja.value.id).then(r => {
                provisorio = r.data
            })
            if (actualStep.value === STEP2) {
                registeredProducts.value.push(...provisorio.map(p => {
                    if (!registeredProducts.value.some(n => n.marca_id === p.marca_id && n.modelo_id === p.modelo_id && n.complemento_id === p.complemento_id)) {
                        const obj = { ...p }
                        obj.quantidade = 0
                        obj.valor = 0.00
                        return obj
                    }
                }))
                registeredProducts.value = registeredProducts.value.filter(p => p !== undefined)
            } else {
                registeredProducts.value = provisorio
            }
            if (check === 1) {
                checkBackup()
            }
        }

        const backupProducts = ref([])
        const goBack = () => {
            console.log('entrei goBack')
            backupProducts.value = [...registeredProducts.value]
            console.log(backupProducts.value)
        }

        const checkBackup = () => {
            console.log('checking', backupProducts.value.length)
            if (backupProducts.value.length > 0) {
                for (const bkp in backupProducts.value) {
                    const index = registeredProducts.value.findIndex(x => x.complemento_id === backupProducts.value[bkp].complemento_id && x.modelo_id === backupProducts.value[bkp].modelo_id && x.marca_id === backupProducts.value[bkp].marca_id)
                    console.log(backupProducts.value[bkp])
                    registeredProducts.value[index].quantidade = backupProducts.value[bkp].quantidade
                    registeredProducts.value[index].valor = backupProducts.value[bkp].valor
                }
            }
        }

        const ultimaRecolha = ref({})
        const getUltimaRecolha = async () => {
            await GET_ULTIMA_RECOLHA(loja.value.id).then(r => {
                ultimaRecolha.value = r.data.resultado
            })
        }

        const produtoUltimaRecolha = ref('')
        const filteredultimaRecolhaProdutos = computed(() => {
            if (produtoUltimaRecolha.value === '') {
                return ultimaRecolha.value.historico
            }
            const compl = ultimaRecolha.value.historico.filter(x => x.complemento.toLowerCase().includes(produtoUltimaRecolha.value.toLowerCase()))
            const marca = ultimaRecolha.value.historico.filter(x => x.marca.toLowerCase().includes(produtoUltimaRecolha.value.toLowerCase()))
            const modelo = ultimaRecolha.value.historico.filter(x => x.modelo.toLowerCase().includes(produtoUltimaRecolha.value.toLowerCase()))
            if (compl.length > 0) { return compl } else if (marca.length > 0) { return marca } else if (modelo.length > 0) { return modelo }
        })

        const confirmaFinalizar = () => {
            
            if (userViewer.role === 'administrador') {
                finalizar()
            } else {
                finalizarModal.value = true
            }
        }

        const loading = ref(false)
        const finalizar = async () => {
            loading.value = true
            finalizarModal.value = false

            const hist = JSON.parse(sessionStorage.getItem('historico'))
            const body = {
                recolha: {
                    loja_id: loja.value.id,
                    ano_mes: hist.ano_mes
                },
                produtos: registeredProducts.value.map(p => ({
                    marca_id: p.marca_id,
                    modelo_id: p.modelo_id,
                    complemento_id: p.complemento_id,
                    quantidade: p.quantidade,
                    valor: p.valor.replaceAll('.', '').replace(',', '.'),
                    observacao: p.observacao
                }))

            }
            await POST_RECOLHA(body).then(r => {
                actualStep.value = STEP4
                completedSteps.value.push(STEP3)
                displayNotification(r)

                hist.loja_id = loja.value.id
                POST_HISTORICO_CONTATOS_ATIVAS(hist).then(r => {
                    displayNotification(r)
                    sessionStorage.removeItem('historico')
                }).catch(e => {
                    displayNotification(e.response)
                })
            }).catch(e => {
                displayNotification(e.response)
            })
            loading.value = false
        }

        const wip = async () => {
            loading.value = true
            const hist = JSON.parse(sessionStorage.getItem('historico'))
            const body = {
                recolha: {
                    loja_id: loja.value.id,
                    ano_mes: hist.ano_mes
                },
                produtos: registeredProducts.value.map(p => ({
                    marca_id: p.marca_id,
                    modelo_id: p.modelo_id,
                    complemento_id: p.complemento_id,
                    quantidade: p.quantidade,
                    valor: p.valor ? p.valor.replaceAll('.', '').replace(',', '.') : '',
                    observacao: p.observacao
                }))

            }
            await POST_RECOLHA_EM_PROGRESSO(body).then(r => {
                actualStep.value = STEP5
                displayNotification(r)

                hist.loja_id = loja.value.id
                hist.status_id = 14
                POST_HISTORICO_CONTATOS_ATIVAS(hist).then(r => {
                    displayNotification(r)
                    sessionStorage.removeItem('historico')
                }).catch(e => {
                    displayNotification(e.response)
                })
            }).catch(e => {
                displayNotification(e.response)
            })
            loading.value = false
        }

        const previousStep = (step) => {
            if (step !== 0) { actualStep.value = step - 1 }
            completedSteps.value = completedSteps.value.filter(s => s !== step)
        }
        const nextStep = (step) => {
            actualStep.value = step + 1
            if (!completedSteps.value.includes(step)) { completedSteps.value.push(step) }
        }

        const selectedProdutos = ref([])
        const initialLoading = ref(true)
        onMounted(async () => {
            await GET_LOJAS_ATIVAS_FILTER(1, { cnpj: route.params.cnpj }).then(r => {
                loja.value = r.data.data[0]
            })

            await GET_MARCAS_BY_SEGMENTO(loja.value.segmento_id).then(r => {
                marcas.value = r.data
            })
            await getRegisteredProducts()
            await getUltimaRecolha()
            initialLoading.value = false
        })

        const filterModelos = async () => {
            if (selectedMarca.value === '') {
                selectedModelo.value = ''
                selectedComplemento.value = ''
            } else {
                selectedModelo.value = ''
                selectedComplemento.value = ''
                const id = findId(marcas.value, selectedMarca.value, 'marca')
                await GET_MODELOS_BY_MARCA(id).then(r => {
                    modelos.value = r.data
                })
            }
        }

        const closeEditModal = async () => {
            await GET_LOJAS_ATIVAS_FILTER(1, { cnpj: route.params.cnpj }).then(r => {
                loja.value = r.data.data[0]
            })
            editModal.value = false
        }

        const filterComplementos = async () => {
            if (selectedModelo.value === '') {
                selectedComplemento.value = ''
            } else {
                const id = findId(modelos.value, selectedModelo.value, 'descricao')
                await GET_COMPLEMENTOS_BY_MODELO(id).then(r => {
                    complementos.value = r.data
                })
            }
            complementos.value = complementos.value.filter(x => {
                if (!registeredProducts.value.some(n => n.complemento_id === x.id)) {
                    return x
                }
            })
        }

        const filteredListComplementos = computed(() => {
            if (selectedModelo.value === '') {
                return []
            }
            if (selectedProdutos.value.length == 0) { return complementos.value }
            return complementos.value.filter(x => !selectedProdutos.value.includes(JSON.stringify({ mc: selectedMarca.value, md: selectedModelo.value, c: x.id })))
        })

        const addProduct = (c) => {
            selectedProdutos.value.push(JSON.stringify({ mc: selectedMarca.value, md: selectedModelo.value, c: c }))
            const body = {
                loja_id: loja.value.id,
                faturamento_id: loja.value.faturamento_id,
                endereco_id: loja.value.endereco_id,
                segmento_id: loja.value.segmento_id,
                marca_id: findId(marcas.value, selectedMarca.value, 'marca'),
                modelo_id: findId(modelos.value, selectedModelo.value, 'descricao'),
                complemento_id: c
            }
            POST_PRODUTOS_LOJA(body).then(r => {
                displayNotification(r)
            }).catch(e => {
                displayNotification(e.response)
            })
        }

        const productToRemove = ref({})

        const openRemoveModal = (marca_id, modelo_id, complemento_id) => {
            productToRemove.value.marca_id = marca_id
            productToRemove.value.modelo_id = modelo_id
            productToRemove.value.complemento_id = complemento_id
            removeModal.value = true
        }

        const remove = async () => {
            
            await removeProduct(productToRemove.value.marca_id, productToRemove.value.modelo_id, productToRemove.value.complemento_id)
            removeModal.value = false
        }

        const removeProduct = async (marca_id, modelo_id, complemento_id) => {
            const p = registeredProducts.value.filter(p => p.marca_id === marca_id && p.modelo_id === modelo_id && p.complemento_id === complemento_id)[0]
            await DELETE_PRODUTOS_LOJA(loja.value.id, { marca_id, modelo_id, complemento_id }).then(r => {
                registeredProducts.value = registeredProducts.value.filter(p => !(p.marca_id === marca_id && p.modelo_id === modelo_id && p.complemento_id === complemento_id))
                displayNotification(r)
            }).catch(e => {
                displayNotification(e.response)
            })
            selectedProdutos.value = selectedProdutos.value.filter(x => !(x === JSON.stringify({ mc: p.marca, md: p.modelo_descricao, c: p.complemento_id })))
        }

        const cnpjMask = cnpj_mask
        const phoneMask = telephoneMask
        const horaMask = timeFormat
        const dataMask = dateTimeFormat

        const isGreaterThan20 = (produto) => {
            if (!produto.valor) {
                return false
            }
            return produto.valor.replaceAll('.', '').replace(',', '.') > (1.2*produto.preco_medio)
        }

        const vIfPercent = (produto) => {
            if (!produto.valor) {
                return false
            }
            return produto.valor.replaceAll('.', '').replace(',', '.') !== '0.00' && produto.valor.replaceAll('.', '').replace(',', '.') !== '0' && produto.preco_medio !== 0 && (produto.valor.replaceAll('.', '').replace(',', '.') > (1.2*produto.preco_medio) || produto.valor.replaceAll('.', '').replace(',', '.') < (0.8*produto.preco_medio))
        }

        const percentCalc = (produto) => {
            const valor = produto.valor.replaceAll('.', '').replace(',', '.')
            console.log(valor, produto.preco_medio)
            if (produto.preco_medio === 0) { return '' }
            if (valor > (1.2 * produto.preco_medio)) { return `${Math.round(parseFloat(valor) * 100 / parseFloat(produto.preco_medio)) - 100}%` } else { return `${100 - Math.round(parseFloat(valor) * 100 / parseFloat(produto.preco_medio))}%` }
        }

        const config = {
            prefix: '',
            suffix: '',
            thousands: '.',
            decimal: ',',
            precision: 2,
            disableNegative: false,
            disabled: false,
            min: null,
            max: null,
            allowBlank: false,
            minimumNumberOfCharacters: 0
        }

        return {
            config,
            actualStep,
            completedSteps,
            loja,

            registeredProducts,

            anomes,
            selectCurrentDate,

            // masks
            cnpjMask,
            phoneMask,
            horaMask,
            dataMask,

            marcas,
            selectedMarca,
            modelos,
            selectedModelo,
            complementos,
            selectedComplemento,
            filterModelos,
            filterComplementos,
            filteredListComplementos,
            selectedProdutos,

            addProduct,
            removeProduct,
            goBack,
            getRegisteredProducts,
            confirmaFinalizar,
            finalizar,
            wip,

            getUltimaRecolha,
            ultimaRecolha,
            produtoUltimaRecolha,
            filteredultimaRecolhaProdutos,

            // step constants
            STEP0,
            STEP1,
            STEP2,
            STEP3,
            STEP4,
            STEP5,
            clickIcons,
            previousStep,
            nextStep,
            loading,
            initialLoading,
            editModal,
            removeModal,
            finalizarModal,
            closeEditModal,
            router,
            isGreaterThan20,
            vIfPercent,
            percentCalc,
            remove,
            openRemoveModal,
            backupProducts
        }
    }

}
</script>

<style>
.fade-enter-from {
  opacity: 0;
  /* transform: translateY(-10%); */
}
.fade-enter-to {
  opacity: 1;
  /* transform: translateY(0%); */
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
  transition-delay: 0.2s;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
  /* transform: translateY(0%); */
}

.fade-leave-to {
  opacity: 0;
  /* transform: translateY(10%); */
}
</style>
